import React from "react";
import RegularButton from "components/CustomButtons/Button"
import EditIcon from '@material-ui/icons/Edit';
import { blue, red } from '@material-ui/core/colors';
import DeleteIcon from '@material-ui/icons/Delete';
import { useToggle } from "hooks/useToggle";
import { ModalV2 } from "components/Modal/ModalV2";
import { PrinterForm } from "./PrinterForm";
import { Typography } from "@material-ui/core";
import LocalPrintshopIcon from '@material-ui/icons/LocalPrintshop';
import { useDispatch } from "react-redux";
import { deletePrinter } from "redux/actions/login/loginActions";
export const columns = [
    {
        "Header": "Nombre",
        "accessor": "name",
        "filterable": true,
        "filterMethod": (filter, row) => { return row.name.toLowerCase().includes(filter.value.toLowerCase()) }
    },
    {
        "Header": "Estación",
        "accessor": "station",
        "filterable": true,
        "filterMethod": (filter, row) => { return row.station.toLowerCase().includes(filter.value.toLowerCase()) }
    },
    {
        "Header": "IP",
        "accessor": "ip",
        "filterable": true,
        "filterMethod": (filter, row) => { return row.ip.toLowerCase().includes(filter.value.toLowerCase()) }
    },
    {
        "Header": "Acciones",
        Cell: ({ original }) => {
            const dispatch = useDispatch()
            const [open, setOpen] = useToggle()
            const [deleteOpen, setDeleteOpen] = useToggle()
            const handleDelete = (e) => {
                e.preventDefault();
                dispatch(deletePrinter(original.id))
                setDeleteOpen()
            }
            return (
                <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 4
                }}>
                    <RegularButton
                        tooltip="Eliminar"
                        round
                        justIcon
                        color="transparent"
                        size="sm"
                        onClick={setDeleteOpen}>
                        <DeleteIcon style={{ color: red[500] }} />
                    </RegularButton>
                    <RegularButton
                        tooltip="Editar"
                        round
                        justIcon
                        color="transparent"
                        size="sm"
                        onClick={setOpen}>
                        <EditIcon style={{ color: blue[500] }} />
                    </RegularButton>
                    <ModalV2
                        open={open}
                        onClose={setOpen}
                        title='Editar impresora'
                    >
                        <PrinterForm isEdit printer={original} onClose={setOpen}/>
                    </ModalV2>
                    <ModalV2
                        open={deleteOpen}
                        onClose={setDeleteOpen}
                        title='Estas seguro de realizar esta acción?'
                        justConfirm
                    >
                        <div style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}>
                            <Typography variant="body1" component="p" style={{
                                color: red[300]
                            }}>
                                Eliminar
                            </Typography>
                            <LocalPrintshopIcon style={{ fontSize: 100, color: blue[500] }} />
                            <Typography variant="body1" component="p">
                                Impresora: {original.name}
                            </Typography>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 8, marginTop: 16 }}>
                                <RegularButton tooltip="cancelar" color="warning" onClick={setDeleteOpen}>Cancelar</RegularButton>
                                <RegularButton tooltip="eliminar" color="danger" onClick={handleDelete}>Eliminar</RegularButton>
                            </div>
                        </div>
                    </ModalV2>
                </div>
            )
        }
    }
]